import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";

interface PrivateRouteProps {
    children: React.ReactNode;
    redirectTo: string;
}

export const PrivateRoute = ({ children, redirectTo }: PrivateRouteProps) => {
    const location = useLocation();
    const isAuthenticated = localStorage.getItem("token");

    return isAuthenticated ? (
        <>{children}</>
    ) : (
        <Navigate to={redirectTo} state={{ from: location }} replace />
    );
};
